export const useLocation = ({ location, active_site }) => {

    return {

        get() {
            return location;
        },

        get region() {
            return location.region
        },


        get country() {
            return location.country_name
        },

        get hasContent() {
            return !_.isEmpty(location.content);
        },


        get content() {
            return location.content;
        },

        get background() {
            if (!_.isEmpty(this.get().background)) {
                return this.get().background;
            }

            let default_location_background = _.find(active_site, (_setting) => { return _setting.key == 'default_location_background'; });

            if (!_.isEmpty(default_location_background)) {
                return default_location_background.value;
            }
        }

    }
}


// WEBPACK FOOTER //
// ./resources/js/react/hooks/useLocation.js